import getCurrentHostname from '../../utils/getCurrentHostname';
import localStore from '../storage/localStore';
import { LOCAL_STORAGE_CLIENT_UUID_KEY } from '../../config/constants';

const deleteOptIn = async (): Promise<void> => {
  try {
    const clientUuid = await localStore.getItem<string>(LOCAL_STORAGE_CLIENT_UUID_KEY);

    if (clientUuid) {
      await fetch(`${getCurrentHostname()}/v2/api/push/opt-in`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'client-uuid': clientUuid,
        },
      });
    }

    return;
  } catch (error) {
    console.error('Push Notification opt-out error: ', error);
    throw error;
  }
};

export default deleteOptIn;
